<template>
  <div>
    <v-data-table v-bind="$attrs"
                  :headers="headers"
                  :items="contacts"
                  :items-per-page="-1"
                  fixed-header
                  height="130px"
                  :footer-props="footerProps"
                  hide-default-footer
                  no-data-text="No recipients yet."
                  dense
                  class="border border-1">
      <template v-slot:top>
        <div class="d-flex justify-space-between align-center px-4 py-1">
          <div class="text-uppercase font-weight-bold text-body-2">
            {{ contacts.length | pluralize('Recipient') }}
          </div>
          <v-btn v-if="hasManyContacts"
                 @click.prevent="removeAllRecipients"
                 color="error"
                 elevation="none"
                 small>
            Remove all
          </v-btn>
        </div>
      </template>
      <template v-slot:item.email="{item: contact}">
        <a @click.prevent="editContact(contact)"
           href="#edit-contact">
          {{ contact.email }}
        </a>
      </template>
      <template v-slot:item.email_deliverability_status="{item: contact}">
        <EmailDeliverabilityStatusWithTooltip :status="contact.email_deliverability_status">
        </EmailDeliverabilityStatusWithTooltip>
      </template>
      <template v-slot:item.status="{item: contact}">
        <UserContactStatus :contact="contact">
        </UserContactStatus>
      </template>
      <template v-slot:item.greeting="{item: contact}">
        <UserContactGreeting :contact="contact">
        </UserContactGreeting>
      </template>
      <template v-slot:item.salutation="{item: contact}">
        <template v-if="contact.salutation">
          {{ contact.salutation }}
        </template>
        <v-chip v-else
                color="orange lighten-4"
                text-color="orange darken-4"
                label
                small
                class="d-block text-center font-weight-bold">
          Missing
        </v-chip>
      </template>
      <template v-slot:item.name="{item: contact}">
        <template v-if="contact.name">
          {{ contact.name }}
        </template>
        <v-chip v-else
                color="orange lighten-4"
                text-color="orange darken-4"
                label
                small
                class="d-block text-center font-weight-bold">
          Missing
        </v-chip>
      </template>
      <template v-slot:item.actions="{item: contact}">
        <v-btn @click.prevent="removeRecipient(contact)"
               dark
               small
               icon
               color="error"
               title="Remove this recipient">
          <v-icon left>
            fas fa-fw fa-times-circle
          </v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <v-dialog v-if="editedContact && editDialog"
              v-model="editDialog"
              max-width="800px">
      <EditUserContactForm :contact="editedContact"
                           @updated="contactUpdated"
                           @closed="closeContactForm">
      </EditUserContactForm>
    </v-dialog>
  </div>
</template>
<script>
import EmailDeliverabilityStatusWithTooltip from '../../neverbounce/components/EmailDeliverabilityStatusWithTooltip.vue';
import UserContactStatus from '../../user-contacts/components/UserContactStatus.vue';
import {Form} from 'vform';
import userContactService from '../../../services/userContactService';
import EditUserContactForm from '../../user-contacts/components/EditUserContactForm.vue';
import UserContactGreeting from '../../user-contacts/components/UserContactGreeting.vue';

export default {
  components: {UserContactGreeting, EditUserContactForm, UserContactStatus, EmailDeliverabilityStatusWithTooltip},
  props: {
    contacts: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      editedContact: null,
      editDialog: false,
      editForm: new Form(userContactService.initForm()),
      newDialog: false,
    }
  },
  computed: {
    hasContacts() {
      return this.contacts.length > 0;
    },
    hasManyContacts() {
      return this.contacts.length > 1;
    },
    footerProps() {
      return {
        'disable-items-per-page': true,
        'disable-pagination': true,
      }
    },
    headers() {
      return [
        {
          text: 'Email',
          value: 'email',
        },
        { // MLD-6164
          text: 'Deliverable',
          value: 'email_deliverability_status',
          width: '140px',
        },
        { // MLD-2844
          text: 'Status',
          value: 'status',
          width: '120px',
        },
        { // MLD-5750
          text: 'Greeting',
          value: 'greeting',
        },
        {
          text: 'Salutation',
          value: 'salutation',
          width: '90px',
        },
        {
          text: 'Name',
          value: 'name',
        },
        {
          text: 'Remove',
          value: 'actions',
          sortable: false,
          align: 'center',
          width: '70px',
        },
      ];
    },
  },
  methods: {
    editContact(contact) {
      console.log('editContact', contact.id)
      this.editedContact = contact;
      this.editForm = new Form(userContactService.initForm(contact));
      if (contact) {
        this.editDialog = true;
      } else {
        this.newDialog = true;
      }
    },
    removeRecipient(recipient) {
      this.$emit('remove-recipient', recipient);
    },
    removeAllRecipients() {
      this.$emit('remove-all-recipients');
    },
    async contactUpdated() {
      const contact = await userContactService.getContact(this.editedContact.id);
      this.$emit('contact-updated', contact)
      this.closeContactForm();
    },
    closeContactForm() {
      this.editedContact = null;
      this.editForm = new Form(userContactService.initForm());
      this.editDialog = false;
      this.newDialog = false;
    },
  }
}
</script>
